import { useEffect, useState } from "react";
import { t, getLang } from "@/lib/i18n";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import api from "@/lib/api";
import Reveal from "@/components/Reveal";

export const formatRate = (r) => (r.rate_min === r.rate_max ? `₹${r.rate_min}` : `₹${r.rate_min}–${r.rate_max}`);
export const formatDate = (iso) => (iso ? new Date(iso).toLocaleDateString(getLang() === "hi" ? "hi-IN" : "en-IN", { day: "numeric", month: "short", year: "numeric" }) : "—");

export default function RatesPreview() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/scrap-rates", { params: { lang: getLang() } }).then((r) => setData(r.data)).catch(() => setData({ rates: [] })); }, []);
  const rows = (data?.rates || []).slice(0, 6);

  return (
    <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24" data-testid="rates-preview-section">
      <div className="grid lg:grid-cols-12 gap-10 items-start">
        <Reveal className="lg:col-span-4">
          <div className="text-xs font-bold tracking-[0.2em] uppercase text-[var(--leaf)]">{t("Scrap rates")} · {t(data?.city || "Jaipur")}</div>
          <h2 className="mt-3 text-3xl sm:text-4xl font-bold leading-tight">{t("Know the price before you sell.")}</h2>
          <p className="mt-4 text-[var(--ink-soft)] leading-relaxed">{t("Indicative per-kg rates, updated by our team. Final price is confirmed after weighing at your door.")}</p>
          <p className="mt-4 text-xs text-[var(--ink-soft)]" data-testid="rates-preview-updated">{t("Last updated")}: {formatDate(data?.updated_at)}</p>
          <Link to="/scrap-rates" className="btn-ghost mt-7 text-sm" data-testid="rates-preview-all-btn">{t("See all rates")} <ArrowRight size={16} /></Link>
        </Reveal>
        <div className="lg:col-span-8 grid sm:grid-cols-2 gap-3">
          {rows.map((r, i) => (
            <Reveal key={r.id} delay={i * 60} className="bg-white rounded-2xl border border-[rgba(20,40,26,.08)] p-5 flex items-center justify-between card-lift" data-testid={`rates-preview-item-${i}`}>
              <div>
                <div className="text-[11px] font-bold uppercase tracking-wider text-[var(--ink-soft)]">{t(r.category)}</div>
                <div className="font-semibold mt-1">{t(r.name)}</div>
              </div>
              <div className="text-right">
                <div className="font-display text-2xl font-bold text-[var(--leaf-dark)]">{formatRate(r)}</div>
                <div className="text-xs text-[var(--ink-soft)]">{t("per")} {t(r.unit)}</div>
              </div>
            </Reveal>
          ))}
          {data && rows.length === 0 && <div className="text-sm text-[var(--ink-soft)]">{t("Rates will be published soon.")}</div>}
        </div>
      </div>
    </section>
  );
}
